export default {
  addFigures(rightFig, leftFig, resultFig) {
    resultFig.fire = rightFig.fire != leftFig.fire
    resultFig.air = rightFig.air != leftFig.air
    resultFig.water = rightFig.water != leftFig.water
    resultFig.earth = rightFig.earth != leftFig.earth
  }
}
